// @flow
import React, { Component } from 'react';

import { AppInstallBannerContext } from './AppInstallBanner.context';

import {
  getIsAndroidDevice,
  getIsIosDevice,
  getIsMobileOrTabletDevice,
} from '../../utils';
import {
  ANDROID_APP_STORE_URL,
  IOS_APP_STORE_URL,
} from '../../constants';

type Props = {
  children: React$Node,
};

type State = {
  isVisible: boolean,
}

export class AppInstallBannerProvider extends Component<Props, State> {
  state = {
    isVisible: false,
  }

  height = 80;

  installBannerKey = 'install-banner-expiration';

  constructor(props: Props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    if (
      getIsMobileOrTabletDevice()
      && this.shouldBannerBeShown()
    ) {
      this.setState({
        isVisible: true,
      });
    }
  }

  shouldBannerBeShown = (): boolean => {
    try {
      const installBannerExpiration = localStorage.getItem(this.installBannerKey);

      if (!installBannerExpiration) {
        return true;
      }

      return Date.parse(installBannerExpiration) < new Date();
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Could not get install-banner-expiration from localstorage: ', e); // eslint-disable-line no-console
      }

      return false;
    }
  }

  preventBannerFromBeingShownForDays = (days: number, fromDate: Date = new Date()) => {
    // Set the time to be the provided date converted time plus
    // the probvided number of days to time (days * hours * mins * seconds * ms)
    fromDate.setTime(fromDate.getTime() + (days * 24 * 60 * 60 * 1000));

    localStorage.setItem(this.installBannerKey, fromDate.toString());
  }

  handleCloseClick = (e: SyntheticMouseEvent<*>) => {
    e.preventDefault();

    this.preventBannerFromBeingShownForDays(2);

    this.setState({
      isVisible: false,
    });
  }

  handleOpenClick = (e: SyntheticMouseEvent<*>) => {
    e.preventDefault();

    this.preventBannerFromBeingShownForDays(30);

    if (getIsIosDevice()) {
      window.open(IOS_APP_STORE_URL); // '_blank' not included because it breaks on chrome iOS
    }

    if (getIsAndroidDevice()) {
      window.open(ANDROID_APP_STORE_URL, '_blank');
    }

    this.setState({
      isVisible: false,
    });
  }

  render() {
    const {
      children,
    } = this.props;

    const {
      isVisible,
    } = this.state;

    return (
      <AppInstallBannerContext.Provider
        value={{
          height: this.height,
          isVisible,
          marginTop: isVisible ? this.height : 0,
          onCloseClick: this.handleCloseClick,
          onOpenClick: this.handleOpenClick,
        }}
      >
        {children}
      </AppInstallBannerContext.Provider>
    );
  }
}

export default AppInstallBannerProvider;
